import nl from './nl.json'

const locales = {
  nl,
}

export default locales
